import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchOverviewSummary({
  cityFilter = [], operationType = "", operatorFilter = [], dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/dashboard/overviewSummary`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter, operationType,
    },
  });
}

export function fetchFinancialOverview({
  cityFilter = [], operationType = "", operatorFilter = [], dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/dashboard/financialOverview`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter, operationType,
    },
  });
}

export function fetchGCOverview({
  cityFilter = [], operationType = "", operatorFilter = [], dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/dashboard/gcOverview`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter, operationType,
    },
  });
}

export function fetchOnlineRechargeSummary({
  cityFilter = [],
  operatorFilter = [],
  dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/dashboard/onlineRechargeSummary`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      date: dateFilter,
    },
  });
}
